import { useState } from 'react';
import { TextArea, TextInput } from '@origo/origo-ui';
import styles from './InstillingerView.module.css';

interface Props {
    initialBeskrivelse?: string;
    initialPlanregisterlink?: string;
    initialGjeldendeBestemmelser?: string;
    onChangeBeskrivelse?: (value: string) => void;
    onChangePlanregisterlink?: (value: string) => void;
    onChangeGjeldendeBestemmelser?: (value: string) => void;
    onUpdateBeskrivelse?: (beskrivelse: string) => Promise<void>;
    onUpdatePlanregisterlink?: (url: string) => Promise<void>;
    onUpdateGjeldendeBestemmelser?: (url: string) => Promise<void>;
}

export function InstillingerView({
    initialBeskrivelse = 'Dette er et forenklet bilde av hva som gjelder for eiendommen din, basert på gjeldende regulering. Den fullstendige og juridisk bindende informasjonen finner du her:',
    initialPlanregisterlink = '',
    initialGjeldendeBestemmelser = '',
    onChangeBeskrivelse,
    onChangePlanregisterlink,
    onChangeGjeldendeBestemmelser,
    onUpdateBeskrivelse,
    onUpdatePlanregisterlink,
    onUpdateGjeldendeBestemmelser,
}: Readonly<Props>) {
    const [beskrivelse, setBeskrivelse] = useState(initialBeskrivelse);
    const [planregisterlink, setPlanregisterlink] = useState(initialPlanregisterlink);
    const [gjeldendeBestemmelser, setGjeldendeBestemmelser] = useState(initialGjeldendeBestemmelser);

    return (
        <div className={styles.panel}>
            <div className={styles.header}> <h2 className={styles.title}>Innstillinger</h2>
                <p className={styles.subHeader}>Innstillinger som gjelder for hele planen.</p></div>

            <TextArea
                label="Beskrivelse av planen"
                helperText="Kort beskrivelse som blir synlig for innbyggerene øverst."
                helperTextPosition="above"
                value={beskrivelse}
                rows={4}
                onChange={(e) => { setBeskrivelse(e.target.value); onChangeBeskrivelse?.(e.target.value); }}
                onBlur={() => onUpdateBeskrivelse?.(beskrivelse)}
            />
            <TextInput
                label="Planregisterlink"
                type="url"
                helperText="Link til planregister"
                value={planregisterlink}
                placeholder='https://'
                onChange={(e) => { setPlanregisterlink(e.target.value); onChangePlanregisterlink?.(e.target.value); }}
                onBlur={() => onUpdatePlanregisterlink?.(planregisterlink)}
            />
            <TextInput
                label="Gjeldende bestemmelser"
                type="url"
                placeholder='https://'
                helperText="Link til gjeldende bestemmelser"
                value={gjeldendeBestemmelser}
                onChange={(e) => { setGjeldendeBestemmelser(e.target.value); onChangeGjeldendeBestemmelser?.(e.target.value); }}
                onBlur={() => onUpdateGjeldendeBestemmelser?.(gjeldendeBestemmelser)}
            />
        </div>
    );
}
